import { groupBy, transform } from 'lodash'
import Payslip from '@/api/hr/payslip'
import PayslipTemplate from '@/api/hr/payslip-template'
import Employee from '@/api/hr/employee'

export const state = {
  reportTemplates: [],
  employees: [],
  payslip: {}
}

export const getters = {}

export const mutations = {
  RECEIVE_TEMPLATES(state, reportTemplates) {
    state.reportTemplates = reportTemplates
  },

  RECEIVE_EMPLOYEES(state, employees) {
    state.employees = employees
  },

  RECEIVE_PAYSLIP(state, payslip) {
    state.payslip = payslip
  },

  RESET_STATE(state) {
    state.employees = []
    state.reportTemplates = []
    state.payslip = {}
  }
}

export const actions = {
  fetch(context, params = {}) {
    return Payslip.get({ params }).then(response => {
      context.commit('RECEIVE_PAYSLIP', response.data)
      return Promise.resolve(response)
    })
  },

  fetchTemplates(context) {
    return PayslipTemplate.get({
      params: { page: -1 }
    }).then(response => {
      context.commit('RECEIVE_TEMPLATES', response.data)
      return Promise.resolve(response)
    })
  },

  fetchEmployees(context) {
    return Employee.get({
      params: { page: -1 }
    }).then(response => {
      context.commit('RECEIVE_EMPLOYEES', response.data)
      return Promise.resolve(response)
    })
  },

  exportExcel(context, { template_id, ...attributes }) {
    return Payslip.exportExcel(template_id, attributes)
  },

  exportPdf(context, { template_id, ...attributes }) {
    return Payslip.exportPdf(template_id, attributes)
  }
}
